import { gsap } from 'gsap';
import { headerHeight, announcementBarHeight } from '../helpers';

if (!window.dAgency) window.dAgency = {};

$(function () {
  const $siteHeader = $('.site-header');
  const $header = $siteHeader.find('.header__container');
  if ($siteHeader <= 0 || $header.length <= 0)
    return false;

  $('html').css('scroll-padding-top', headerHeight() + 'px');
  $('#PageContainer').css('min-height', 'calc(100vh - ' + headerHeight() + 'px)');

  $(window).on('resize orientationchange headerHeightChange', function () {
    $('html').css('scroll-padding-top', headerHeight() + 'px');
    $('#PageContainer').css('min-height', 'calc(100vh - ' + headerHeight() + 'px)');
  });

  /* ======================== Header ======================== */
  if ($header.hasClass('header__transparent')) {
    if ($(window).scrollTop() === 0) {
      $header.addClass('apply-transparency');
    } else {
      $header.removeClass('apply-transparency');
    }

    $(window).on('scroll', function () {
      if (!$header.hasClass('force-opacity')) {
        if ($(window).scrollTop() === 0) {
          $header.addClass('apply-transparency');
        } else {
          $header.removeClass('apply-transparency');
        }
      }
    });
  }

  $header.on('mouseenter', function () {
    if ($(window).outerWidth() > 1024) {
      $header.removeClass('apply-transparency');
    }
  });
  $header.on('mouseleave', function () {
    if ($(window).scrollTop() === 0 && $(window).outerWidth() > 1024 && !$header.hasClass('force-opacity')) {
      $header.addClass('apply-transparency');
    }
  });

  $header.find('.header__left__newsletter-button').on('click', function () {
    if (typeof (window.dAgency.showNewsletterPopUp) === 'function') window.dAgency.showNewsletterPopUp();
  });

  /* ======================== Mobile Menu ======================== */
  const $mobileMenu = $header.find('.header__mobile-menu');
  if ($mobileMenu.length > 0) {
    if ($mobileMenu.hasClass('header__mobile-menu--drawer')) {
      const $secondLevel = $mobileMenu.find('.header__mobile-menu--drawer__second-level');
      $secondLevel.each(function (element, index) {
        const $level = $(this);
        const $close = $(this).find('.header__mobile-menu--drawer__second-level__close');
        $close.on('click', function () {
          $level.removeClass('open');
        });

        const $titles = $(this).find('.header__mobile-menu--drawer__second-level__title');
        $titles.each(function () {
          const accordionIndex = $(this).data('accordion-index');
          const $otherThirdLevels = $level.find('.header__mobile-menu--drawer__third-level:not([data-accordion-index="' + accordionIndex + '"])');
          const $connectedThirdLevel = $level.find('.header__mobile-menu--drawer__third-level[data-accordion-index="' + accordionIndex + '"]');

          $(this).on('click', function (e) {
            if (e.target.getAttribute('href')) return;

            if ($(this).hasClass('open')) {
              $(this).removeClass('open');
              $connectedThirdLevel.slideUp();
            } else {
              $titles.removeClass('open');
              $otherThirdLevels.slideUp();
              $(this).addClass('open');
              $connectedThirdLevel.slideDown();
            }
          });
        });
      });

      $('.header__mobile-menu--drawer__icon-close').on('click', function () {
        $($mobileMenu).removeClass('open');
      });
    }

    const burgerTop = document.getElementById('burger-bar-top');
    const burgerMiddle = document.getElementById('burger-bar-middle');
    const burgerBottom = document.getElementById('burger-bar-bottom');
    const $searchBar = $header.find('.header__search-popup');
    var tl = gsap.timeline();

    var isMenuOpen = false;
    $header.find('.header__burger-icon').on('click', function () {
      isMenuOpen = !isMenuOpen;
      $mobileMenu.toggleClass('open');
      $searchBar.removeClass('open');

      if (isMenuOpen) {
        $mobileMenu.css('height', 'calc(100dvh - ' + announcementBarHeight() + 'px)'); //fix attempt because of iOS browser toolbar
        $('html').css('overflow-y', 'hidden');
        $header.removeClass('apply-transparency');
        $header.addClass('force-opacity');

        tl = gsap.timeline();
        tl.to(burgerTop, { rotate: 45, duration: 1, y: 7, transformOrigin: 'center', ease: 'elastic.out(1, 0.4)' }, 0);
        tl.to(burgerMiddle, { scaleX: 0, duration: 1, opacity: 0, transformOrigin: 'center', ease: 'elastic.out(1, 0.4)' }, 0);
        tl.to(burgerBottom, { rotate: -45, duration: 1, y: -7, transformOrigin: 'center', ease: 'elastic.out(1, 0.4)' }, 0);
      } else {
        $('html').css('overflow-y', '');
        $header.removeClass('force-opacity');
        if ($(window).scrollTop() === 0) {
          $header.addClass('apply-transparency');
        }

        tl = gsap.timeline();
        tl.to(burgerTop, { rotate: 0, duration: 1, y: 0, transformOrigin: 'center', ease: 'elastic.out(1, 0.4)' }, 0);
        tl.to(burgerMiddle, { scaleX: 1, duration: 1, opacity: 1, transformOrigin: 'center', ease: 'elastic.out(1, 0.4)' }, 0);
        tl.to(burgerBottom, { rotate: 0, duration: 1, y: 0, transformOrigin: 'center', ease: 'elastic.out(1, 0.4)' }, 0);
      }
    });

    const $mobileMenuImages = $('.header__mobile-menu__level__image');
    if ($mobileMenuImages.length > 0) {
      $mobileMenuImages.each(function () {
        const $links = $(this).prev();
        $links.css('height', 'calc(100% - ' + $(this).innerHeight() + 'px - 1rem)');
      });
    }

    $('[data-mobile-menu-opener]').on('click', function (e) {
      if (!e.target.getAttribute('href')) {
        const menuName = $(this).data('mobile-menu-opener');
        $('[data-mobile-menu="' + menuName + '"]').css('transform', 'translate3d(0, 0, 0)');
      }
    });

    $('[data-mobile-menu] .header__mobile-menu__level__title').on('click', function () {
      const $menu = $(this).closest('.header__mobile-menu__level');
      $menu.css('transform', '');
    });
  }

  /* ======================== Desktop Menu ======================== */
  const $desktopMenu = $header.find('.header__desktop-menu');
  if ($desktopMenu.length > 0) {
    if ($desktopMenu.hasClass('header__desktop-menu--drawer')) {
      const $firstLevelLinks = $desktopMenu.find('.header__desktop-menu--drawer__inline-elements__link')
      $firstLevelLinks.each(function () {
        $(this).on('mouseenter', function () {
          if ($(window).outerWidth() <= 1024) return;

          $header.addClass('force-opacity');
          $(this).addClass('open');
          $('html').css('overflow-y', 'hidden');
        });

        $(this).on('mouseleave', function () {
          if ($(window).outerWidth() <= 1024) return;

          $header.removeClass('force-opacity');
          $(this).removeClass('open');
          $(this).find('.open').removeClass('open');
          $('html').css('overflow-y', '');
        });
      });

      $desktopMenu.find('.header__desktop-menu--drawer__second-level').each(function () {
        $(this).css('height', 'calc(100vh - ' + headerHeight() + 'px)');
        $(window).on('resize orientationchange headerHeightChange', function () {
          $(this).css('height', 'calc(100vh - ' + headerHeight() + 'px)');
        });

        const $level = $(this);
        $(this).find('.header__desktop-menu--drawer__second-level__title.clickable').on('click', function (e) {
          if (e.target.getAttribute('href')) return;

          const levelIndex = $(this).data('submenu');
          $level.find('.header__desktop-menu--drawer__third-level[data-submenu="' + levelIndex + '"]').addClass('open');
        });
      });

      $(this).find('.header__desktop-menu--drawer__third-level').each(function () {
        const $thirdLevel = $(this);
        const $overflowContainer = $(this).find('.header__desktop-menu--drawer__third-level__overflow-container');
        const $goBack = $(this).find('.header__desktop-menu--drawer__third-level__go-back');

        $overflowContainer.css('height', 'calc(100% - ' + $goBack.outerHeight() + 'px)');
        $goBack.on('click', function () {
          $thirdLevel.removeClass('open');
        });
      });
    }
  }

  /* ==================== Desktop Search PopUp ==================== */
  const $searchBar = $header.find('.header__search-popup');
  if ($searchBar.length > 0) {
    $searchBar.css('top', headerHeight(true) + 'px');

    const $iconSearch = $header.find('.header__right__element.search');
    if ($iconSearch.length > 0) {
      $iconSearch.on('click', function (e) {
        e.preventDefault();
        $searchBar.toggleClass('open');

        if ($searchBar.hasClass('open')) {
          $header.removeClass('apply-transparency');
          $header.addClass('force-opacity');
          $searchBar.find('form input[type="text"]').trigger('focus');
        } else {
          $header.removeClass('force-opacity');
          if ($(window).scrollTop() === 0) {
            $header.addClass('apply-transparency');
          }
        }
      });
    }

    $(window).on('resize orientationchange headerHeightChange', function () {
      $searchBar.css('top', headerHeight(true) + 'px');
    });

    const $closeIcon = $searchBar.find('.header__search-popup__close-icon');
    if ($closeIcon.length > 0) {
      $closeIcon.on('click', function () {
        $searchBar.removeClass('open');
        $header.removeClass('force-opacity');
        if ($(window).scrollTop() === 0) {
          $header.addClass('apply-transparency');
        }
      });
    }
  }
});
